import { styled } from '@mui/material/styles';
import { Typography } from '@mui/material';

export const StyledDateTimeContainer = styled('div')(
  ({ theme }) => `
  margin-top: ${theme.DS_spacing(['md'])};
  margin-bottom: ${theme.DS_spacing(['xlx'])};
  
    p {
   margin-top: ${theme.DS_spacing(['xs'])};
   }
`,
);

export const Date = styled(Typography)(
  ({ theme }) => `
   margin-bottom: ${theme.DS_spacing(['xs'])};
`,
);

export const TimesContainer = styled('div')(
  ({ theme }) => `
  display: grid;
  column-gap: ${theme.DS_spacing(['xxs'])};
  row-gap: ${theme.DS_spacing(['md'])};
  grid-template-columns: repeat(auto-fill, 102px);
  grid-template-rows: repeat(auto-fill, 3rem);

`,
);

export const sharedHoverCardsStyles = ({ theme }) => `
    border: 2px solid ${theme.DS_palette.buttons.enabled};
    padding: ${theme.DS_spacing(['xxs'])} ${theme.DS_spacing(['md'])};
   font-weight: ${theme.typography.DS_copyMediumBold.fontWeight};
`;

const buttonActive = ({ theme, active }) =>
  active &&
  `
    ${sharedHoverCardsStyles({ theme })}
  `;

export const TimeButton = styled('button')(
  ({ theme, active }) => `
  font-family: ${theme.typography.DS_copyMediumRegular.fontFamily};
  font-size: ${theme.typography.DS_copyMediumRegular.fontSize};
  font-weight: ${theme.typography.DS_copyMediumRegular.fontWeight};
  line-height: ${theme.typography.DS_copyMediumRegular.lineHeight};
  letterSpacing: ${theme.typography.DS_copyMediumRegular.letterSpacing};

  padding:  ${theme.DS_spacing(['xxsx'])} ${theme.DS_spacing(['md'])};
  border: 1px solid ${theme.DS_palette.border.form};
  border-radius: ${theme.DS_border.radius.dates};
  
  &:hover {
    ${sharedHoverCardsStyles({ theme })}
  }
  
  ${buttonActive({ theme, active })};

`,
);
